<template>
	<div class="odd-header">
		<div class="tabs tabs-style-bar" v-if="odds">
			<nav>
				<ul>
					<swiper :options="swiperOption"ref="sw">
						<swiper-slide v-for="market in markets" v-if="finded.includes(market.id) || market.id == 0">

								<li
								    :class="(selectedMarket == market.id) ? 'tab-current' : ''"
								    v-on:click="selectMarkets(market.id)">
									<a href="javascript:void();">
										<span>{{ market.name }}</span>
									</a>
								</li>

						</swiper-slide>
						<div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div>
					</swiper>
				</ul>
			</nav>
		</div>
	</div>
</template>

<script>
    import Swiper from 'swiper/dist/js/swiper.js'
    export default {
        name: "oddHeader",
        data () {
            return {
                t: this.$root.t,
	            selectedMarket: 0,
	            markets: [
                    {name: 'Tumu', id: 0, i: 'icon-grid'},
		            {name: 'Main', id: 1, i: 'entypo-icon-tv'},
                    {name: 'Fav', id: 111, i: 'entypo-icon-shield'},
                    {name: 'Handikap', id: 17, i: 'entypo-icon-resize-full-screen'},
                    {name: 'Toplam', id: 15, i: 'entypo-icon-code'},
                    {name: '1. Ceyrek', id: 21, i: 'ti-time'},
                    {name: '2. Ceyrek', id: 22, i: 'ti-time'},
                    {name: '3. Ceyrek', id: 23, i: 'ti-time'},
                    {name: '4. Ceyrek', id: 24, i: 'ti-time'},
                    {name: '1. Period', id: 30, i: 'ti-time'},
                    {name: '2. Period', id: 31, i: 'ti-time'},
                    {name: '3. Period', id: 32, i: 'ti-time'},
                    {name: 'İlk yarı', id: 14, i: 'entypo-icon-circular-graph'},
                    {name: 'İkinci yarı', id: 16, i: 'entypo-icon-circle'},
                    {name: 'Korner', id: 2, i: 'entypo-icon-popup'},
                    {name: 'Oyuncu', id: 53, i: 'entypo-icon-user'},
                    {name: 'Oyuncu', id: 100, i: 'entypo-icon-user'},
                    {name: 'Faul', id: 100, i: 'entypo-icon-notification'},
                    {name: 'Taç', id: 100, i: 'entypo-icon-align-vertical-middle'},
                    {name: 'Kart', id: 33, i: 'entypo-icon-documents'},
                    {name: 'Shot', id: 100, i: 'entypo-icon-vinyl'},
                    {name: 'Offside', id: 100, i: 'entypo-icon-flag'},
                    {name: 'Değişiklik', id: 100, i: 'entypo-icon-swap'},
                    {name: 'Top Poz.', id: 100, i: 'entypo-icon-shareable'},
                    {name: 'Diğer', id: 18, i: 'entypo-icon-dots-three-horizontal'},
	            ],
	            finded: [],
                swiperOption: {
                    slidesPerView: 8,
                    spaceBetween: 0,
                    // init: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                }
            }
        },
	    props: ['odds'],
	    mounted () {
            this.findMarkets()
	    },
        updated () {
            setTimeout( this.findMarkets(), 300);
	    },
        computed: {
            sw() {
                return this.$refs.sw
            },
        },
	    methods: {
            findMarkets() {
                for (var key in this.odds) {
                    for (var mx in this.odds[key].markets) {
                        if (this.finded.indexOf(this.odds[key].markets[mx]) == -1) {
                            this.finded.push(this.odds[key].markets[mx]);
                        }
                    }
                }
            },
            selectMarkets(Market) {
                this.selectedMarket = Market;
                this.$emit('selected', Market);
            }
	    }
    }
</script>

<style scoped>
	.swiper-button-disabled {
		display: none;
	}
	.swiper-container {
		width: 90vw;
	}
	.swiper-slide {
		width: 5vw;
	}
	.odd-header {
		background: radial-gradient(ellipse at center, rgba(255,242,242,1) 0%,rgba(244,244,244,1) 49%,rgba(216,216,216,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	}
	.nav-item {
		font-size: 9px
	}
	i {
		display: block;
		font-size: 24px;
	}
	.tabs-style-iconbox nav ul li a {
		padding: 1em 0;
	}

</style>


// WEBPACK FOOTER //
// src/components/stats/odds/oddHeader.vue